import React from 'react';
import { TriangleAlert } from 'lucide-react';
import { ResultCard } from '../ResultCard';

interface ErrorPageProps {
  title?: string;
  message?: string;
  link?: {
    label: string;
    url: string;
  };
}

/**
 * A whole screen given over to something having gone wrong, before sign-in.
 *
 * It was a 96px yellow warning triangle over a 36px headline, which is the
 * loudest thing in the app for what is usually a stale link. It is the shared
 * result template now — same shape as "email verified" and "invitation
 * expired", because an error is a result too: say what happened, offer the way
 * on.
 */
export const ErrorPage: React.FC<ErrorPageProps> = ({ title, message, link }) => (
  <div
    className="flex min-h-screen items-center justify-center bg-surface px-4 py-12"
    data-testid="error-page"
  >
    <ResultCard
      tone="warning"
      icon={TriangleAlert}
      title={title ?? 'Something went wrong'}
      description={message}
      action={link ? { label: link.label, href: link.url } : undefined}
    />
  </div>
);
